<div class="dropdown container-fluid">
  <form [formGroup]="filterForm">
    <div class="row flex justify-between">
      @for(item of filters; track $index){
      <div class="col-auto">
        @switch (item?.type) { 
            @case ('dropdown') {
                <app-global-dropdown
                [formControlName]="item.key"
                [options]="options[item.key] || []"
                [data]="item"
                >
                </app-global-dropdown>
            } 
            @case ('slider-range') {
                <app-mat-slider [data]="item">                     
                </app-mat-slider>
            } 
             @case ('button') {
       <app-button
  [data]="item"
  [selectedKey]="selectedKey"
  (selectionChange)="onButtonSelectionChange($event)">
</app-button>

            } 
              @case ('icon') {
        <mat-icon (click)="download(item.apiUrl)" style="cursor:pointer;margin-top: 2.2rem;">download</mat-icon>
        }

            @default {} 
          }
      </div>
      }
      <div class="col-auto mt-3">
        <div (click)="resetButton()" class="reset d-flex align-items-center" style="cursor: pointer;">
          <mat-icon class="material-symbols-outlined me-1">filter_alt</mat-icon>
          <span>RESET FILTERS</span>
        </div>
      </div>
    </div>
  </form>
</div>
